export default __webpack_public_path__ + "static/media/teacherTeaching.3c8fe852.svg";